export default __webpack_public_path__ + "static/media/image-6.4f6769a8.gif";